import type { ResolvableServicePage_CostUsagesList_CostUsage } from '..';

export const getRowId = (row: ResolvableServicePage_CostUsagesList_CostUsage) =>
  row.cost._id;
